// import ApolloClient from 'apollo-client';
import { SetContextLink } from '@apollo/client/link/context';
import { InMemoryCache } from '@apollo/client/cache';

import { ApolloClient } from '@apollo/client/core';
import { HttpLink, ApolloLink } from '@apollo/client';
import { ErrorLink } from '@apollo/client/link/error';
import { CombinedGraphQLErrors } from '@apollo/client/errors';

const cache = new InMemoryCache();

const errorLink = new ErrorLink(({ error }) => {
    if (CombinedGraphQLErrors.is(error)) {
        error.errors.forEach(({ message }) => console.log(message));
    }
});

const httpLink = new HttpLink({
    uri: (import.meta.env.VITE_GRAPHQL ?? '') + '/api/graphqlEndpoint',
});

const authLink = new SetContextLink((prevContext) => {
    const token = sessionStorage.getItem('accessToken');
    return {
        headers: {
            ...prevContext.headers,
            authorization: token ? `Bearer ${token}` : '',
        },
    };
});

const client = new ApolloClient({
    link: ApolloLink.from([errorLink, authLink, httpLink]),
    cache,
});

export default client;
